import { ModuleWithProviders, NgModule } from '@angular/core';
// Uncomment if you are building a library with a component.
// import { LibraryTemplateLibComponent } from './ngx-sentry-component/ngx-sentry.component';

// Uncomment if you are building a library with a service.
import { SentryLoggingService } from './sentry.service';

/**
 * The Sentry library module. By importing this module in to another, the necessary default providers will be set, including `LOGGER_SERVICE`. However,
 * it will still be necessary to provide your own `ERROR_LOGGER_OPTIONS`, including the Sentry DSN.
 *
 * ### Example
 * ```
...
imports: [ SentryLoggingModule.forRoot() ]
providers: [{
   provide: 'ERROR_HANDLER_OPTIONS', useValue: { dsn: 'https://<key>@sentry.io/<project>' }
}]
...
 ```
 */
@NgModule({
    imports: [ ]
})

export class SentryLoggingModule {
    /** @ignore */
    static forRoot (): ModuleWithProviders<SentryLoggingModule> {
        return {
            ngModule: SentryLoggingModule,
            providers: [
                SentryLoggingService,
                // The logging service
                { provide: 'LOGGER_SERVICE', useClass: SentryLoggingService }
            ]
        };
    }
}
